import { window } from "../window";
import { externalRedirectPropTypes } from "./ExternalRedirect.propTypes";
import { ExternalRedirectProps } from "./ExternalRedirect.types";

/**
 * The ExternalRedirect component updates window.location.href, causing an external redirect.
 */

export const ExternalRedirect = (props: ExternalRedirectProps) => {
  const { to } = props;

  window.location.href = to;

  return null;
};

ExternalRedirect.displayName = "ExternalRedirect";
ExternalRedirect.propTypes = externalRedirectPropTypes;
